var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:['space-y-2 w-150 rounded radio-button-set', {
  'p-2 border border-solid border-danger invalid': _vm.invalid,
}]},_vm._l((_vm.options),function(val,index){return _c('li',{key:(index + "-" + val)},[_c('RadioButton',{attrs:{"size":_vm.size,"value":_vm.value,"checked":val === _vm.value},on:{"change":function($event){return _vm.$emit('input', val)}}},[_vm._v(_vm._s(val.name))])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }